import { render, staticRenderFns } from "./GroupAdd.vue?vue&type=template&id=8e4344bc&scoped=true"
import script from "./GroupAdd.vue?vue&type=script&lang=js"
export * from "./GroupAdd.vue?vue&type=script&lang=js"
import style0 from "./GroupAdd.vue?vue&type=style&index=0&id=8e4344bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4344bc",
  null
  
)

export default component.exports